import { Typography } from '@mui/material';
import { t } from '../constants/translations';
import { useLocale } from '../contexts/locale.context';

const AccessDenied = () => {
  const { lang } = useLocale();
  return (
    <Typography variant="h5" sx={{ textAlign: 'center', p: 3 }}>
      {t.access_denied[lang]}
    </Typography>
  );
};

export default AccessDenied;
